export const isMobile = () => window.innerWidth < 992;